// extracted by mini-css-extract-plugin
export default {"spell":"styles_spell__yDHQ1","callout":"styles_callout__qugv2"};